import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PipelineEdit from '../components/PipelineEdit'
import {
  actionCreators,
  selectEditCriticalDateIndex,
  selectCheckPipelineExists,
  selectError,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectPipeline,
  selectShowCriticalDateModal,
  selectListingType,
  IPipelineEditState,
} from '../modules/pipelineEdit'

export default connect(
  createStructuredSelector<ApplicationState, IPipelineEditState>({
    editCriticalDateIndex: selectEditCriticalDateIndex(),
    hasExistingPipeline: selectCheckPipelineExists(),
    error: selectError(),
    isLoading: selectIsLoading(),
    isReady: selectIsReady(),
    isSaving: selectIsSaving(),
    pipeline: selectPipeline(),
    listingType: selectListingType(),
    showCriticalDateModal: selectShowCriticalDateModal(),
  }),
  actionCreators,
)(PipelineEdit)
